import React, { useCallback, useEffect, useState } from "react";
import {
  DataGridPro,
  GridFilterPanel,
  GridLogicOperator,
  useGridApiRef,
  gridPaginationModelSelector,
} from "@mui/x-data-grid-pro";
import SaveUserFilter from "./SaveUserFilter";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import GridHeaderBar from "./GridHeaderBar";
import { useItemSelectedFilterContext } from "../../../Context/GridEquipListContext";
import { parseDate } from "../../ReusableComponent/DatePickerComponent/DatePickerComponent";
import dayjs from "dayjs";
import { _helper } from "../../GlobalFunction/dateHelper";
import { LocalizationDataGridConst } from "../../ReusableComponent/DataGrid/LocalizationDataGrid";
import { useLanguageContext } from "../../../Context/LanguageContext";
import CustomFilterPanel from "./FilterComponet";
import CopyBox from "../../MessageBox/CopyBox";

const MuiDataGridPro = React.memo(function MuiDataGridPro({
  tableData,
  handlePaginationCall,
  handleFilter,
  handleSorting,
  children,
  reportCode,

  handelStateStatus,
  pinnedColumns,
  handleColumnPin,
  saveFilterlist,
  clearFilterKey,
  state,
  saveFilterHandler,
  onRowDoubleClick,
}) {
  const { localization } = useLanguageContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const [messageBoxText, setMessageBoxText] = useState({});
  const [dialogboxOpen, setdialogOpen] = useState(false);
  const [msgButtons, setMsgButtons] = useState([]);
  const [copyAnzahl, setCopyAnzahl] = useState(null);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 1000,
  });

  const apiRef = useGridApiRef();
  const suppressPaginationRef = React.useRef(false);
  const programmaticPaginationRef = React.useRef(null);

  // When parent signals a clear (e.g. equipment group changed), clear the DataGrid filter UI
  React.useEffect(() => {
    if (typeof clearFilterKey !== "undefined" && apiRef && apiRef.current) {
      try {
        apiRef.current.setFilterModel({ items: [] });
        apiRef.current.hideFilterPanel();
      } catch (e) {
        // ignore
      }
    }
  }, [clearFilterKey, apiRef]);
  
  // When parent provides a filter model in tableData (e.g., selecting saved filter), apply it to the grid UI
  React.useEffect(() => {
    try {
      if (
        tableData &&
        tableData.filterModel &&
        apiRef &&
        apiRef.current
      ) {
        apiRef.current.setFilterModel(tableData.filterModel);
      }
    } catch (e) {
      // ignore
    }
  }, [apiRef, tableData && JSON.stringify(tableData.filterModel)]);
  const [saveFilterModel, setSaveFilterModel] = useState([]);

  const handlePinnedColumnsChange = React.useCallback(() => {
    const currentPinnedColumns = apiRef.current.getPinnedColumns();
    handleColumnPin(currentPinnedColumns);
  }, [apiRef]);

  const handleSortModelChange = React.useCallback((sortModel) => {
    handleSorting(sortModel, itemSelectedFilter);
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {}, []);

  const handlePagination = React.useCallback(
    (pageModal) => {
      let _tempModel = {};
      if (paginationModel.pageSize === pageModal.pageSize) {
        _tempModel = {
          page:
            paginationModel.page > pageModal.page
              ? paginationModel.page
              : pageModal.page + 1,
          pageSize: paginationModel.pageSize,
        };
      } else {
        _tempModel = {
          page: 1,
          pageSize: pageModal.pageSize,
        };
      }

      handlePaginationCall(_tempModel, itemSelectedFilter);
    },
    [paginationModel],
  );

  const handleApplyFilters = (_key, _filterValue) => {
    handleFilter(_filterValue, _key);
  };

  useEffect(() => {
    setPaginationModel({
      page: tableData.paginationData.currentPage - 1,
      pageSize: tableData.paginationData.pageSize,
    });
  }, [tableData.paginationData]);

  // When we programmatically update paginationModel, prevent firing the change handler
  React.useEffect(() => {
    const progModel = {
      page: tableData.paginationData.currentPage - 1,
      pageSize: tableData.paginationData.pageSize,
    };
    programmaticPaginationRef.current = progModel;
    suppressPaginationRef.current = true;
    setPaginationModel(progModel);
  }, [tableData.paginationData.currentPage, tableData.paginationData.pageSize]);

  function handleSave() {}

  const closeMsg = () => {
    setdialogOpen(false);
  };

  function handleInput(filterName) {
    sessionStorage.setItem("filName", filterName);
    setCopyAnzahl(filterName);
  }

  function handleSaveFilterCallBack(fieldName, _filterList, key, itemSelected) {
    const _id =
      itemSelected !== ""
        ? itemSelected[0].title === fieldName
          ? itemSelected[0].id
          : null
        : null;
    if (
      !_id &&
      saveFilterlist.length > 0 &&
      saveFilterlist.some(
        (item) => item.title.toLowerCase() === fieldName.toLowerCase(),
      )
    ) {
      alert("Filter already exists");
      return;
    }
    saveFilterHandler(_filterList, "save", fieldName, _id);
    setdialogOpen(false);
  }

  const handleSaveFilter = (key, _filterModel, filterList) => {
    apiRef.current.hideFilterPanel();

    setMessageBoxText({
      title: localization.enterfiltername,
      msg: "",
      anlageID: "",
    });

    setMsgButtons([
      {
        title: localization.cancelbutton,
        func: closeMsg,
        type: "cancel",
      },
      {
        title: localization.save,
        func: (fieldname) => {
          handleSaveFilterCallBack(fieldname, _filterModel, key, filterList);
        },
        type: "ok",
      },
    ]);

    setdialogOpen(true);
  };

  return (
    <>
      <DataGridPro
        id="dataGridProMainGrid"
        rows={tableData.data}
        columns={tableData.columns}
        onRowDoubleClick={onRowDoubleClick}
        checkboxSelection={false}
        density="compact"
        localeText={{
          ...LocalizationDataGridConst(localization),
        }}
        onSortModelChange={handleSortModelChange}
        sortModel={tableData.sortingModal}
        sortingMode="server"
        sortingOrder={["asc", "desc"]}
        slots={{
          toolbar: () => <>{children}</>,

          filterPanel: (props) => (
            <CustomFilterPanel
              filterModel={tableData.filterModel}
              onApply={handleApplyFilters}
              localization={localization}
              onFilterSave={handleSaveFilter}
              saveFilterlist={saveFilterlist}
              reportCode={reportCode}
              tableData={{
                headerName: tableData.headerName,
                hearderType: tableData.hearderType,
                pagination: tableData.paginationData.pageSize,
              }}
              apiRef={apiRef}
            />
          ),
        }}
        slotProps={{
          pagination: {
            labelRowsPerPage: localization.rowsPerPage,
          },
          filterPanel: {
            // Force usage of "And" operator
          },
        }}
        sx={{
          "& .action-cell": {
            border: "none", // Remove border
            justifyContent: "flex-start",
            padding: 0,
          },
        }}
        filterMode="server"
        initialState={{
          filter: {
            filterModel: tableData.filterModel, // Use the initial filter model
          },
          // sorting: {
          //   sortModel: tableData.sortingModal,
          // },
          pinnedColumns: pinnedColumns,
        }}
        columnBuffer={tableData.headerName.length}
        onFilterModelChange={onFilterChange}
        pagination
        pageSizeOptions={[50, 100, 500, 1000]}
        {...tableData.paginationData}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={(newModel) => {
          if (suppressPaginationRef.current) {
            const prog = programmaticPaginationRef.current;
            // If the incoming model matches the programmatic model, ignore it.
            if (prog && prog.page === newModel.page && prog.pageSize === newModel.pageSize) {
              suppressPaginationRef.current = false;
              programmaticPaginationRef.current = null;
              return;
            }
            // Otherwise clear suppression and allow this user-driven change to proceed.
            suppressPaginationRef.current = false;
            programmaticPaginationRef.current = null;
          }
          // convert to 1-based page number expected by parent
          const pageModel = { page: newModel.page + 1, pageSize: newModel.pageSize };
          handlePaginationCall(pageModel, itemSelectedFilter);
        }}
        disableRowSelectionOnClick={false}
        onPinnedColumnsChange={handlePinnedColumnsChange}
        apiRef={apiRef}
      />
      <CopyBox
        isOpen={dialogboxOpen}
        text={messageBoxText}
        functions={msgButtons}
        close={closeMsg}
        copyAnzahl={copyAnzahl}
        //  setCopyAnzahl={setCopyAnzahl}
        handleInput={handleInput}
        placeholderName={localization.enterfiltername}
        _type="text"
      />
    </>
  );
});
export default MuiDataGridPro;

let tableProperty = {
  columnsSort: "asc",
  filterFormProps: {
    logicOperators: [],
    logicOperatorInputProps: {
      variant: "outlined",
      size: "small",
    },
    columnInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    operatorInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    valueInputProps: {
      InputComponentProps: {
        variant: "outlined",
        size: "small",
      },
    },
    deleteIconProps: {
      sx: {
        "& .MuiSvgIcon-root": { color: "#d32f2f" },
      },
    },
  },
  sx: {
    // Customize inputs using css selectors
    "& .MuiDataGrid-filterForm": { p: 2 },
    "& .MuiDataGrid-filterForm:nth-child(even)": {
      backgroundColor: (theme) =>
        theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
    },
    "& .MuiDataGrid-filterFormLogicOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormColumnInput": { mr: 2, width: 150 },
    "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormValueInput": { width: 200 },
  },
};
